import React from 'react'
import Socials from '../Socials'

const Footer = () => {
  return (
    <footer className='Footer'>
      <Socials />
      <div className='footer-txt'>
        <p>Designed & Built by Stephan Benchemoul</p>
      </div>
    </footer>
  )
}

export default Footer
